module.exports = __webpack_public_path__ + "media/LandingPageAssets/chatImage1-79608842.png";